/* global */
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom';

const RxComponent = global.rootRequire('components/shares/rxComponent').default
const { rxaget, secondsToTime, isElectron, changeColorSVG } = global.rootRequire('classes/ulti')
const { checkNameUser } = global.rootRequire('classes/chat')
const { rxgetLocal } = global.rootRequire('classes/request')

const rxio = global.rootRequire('classes/socket').default
const chatDB = global.rootRequire('classes/indexedDB').default


class JoinGroupCallComponent_ extends RxComponent {
    constructor(props, context) {
        super(props, context)
        this.state = {}
        this.callObj = {}

        this.userid = rxaget(this.props, 'netaauth.user.id', '')
        this.token = rxaget(this.props, 'netaauth.user.token', '')
    }

    componentDidMount() {
        try {
            if (this.props && this.props.location && this.props.location.search && this.props.location.search.indexOf('join_meet') !== -1) {
                console.log(this.props.location.search)
                let strParams = this.props.location.search.replace('?', '')
                let arrParams = strParams.split('&')
                let joinMeetId = ''
                for (let param of arrParams) {
                    if (param.indexOf('join_meet=') !== -1) {
                        joinMeetId = param.replace('join_meet=', '')
                        break
                    }
                }
                if (joinMeetId && joinMeetId.indexOf('-') !== -1) {
                    let arrParamsMeet = joinMeetId.split('-')
                    if (arrParamsMeet && arrParamsMeet.constructor === Array && arrParamsMeet.length > 1) {
                        let groupId = arrParamsMeet[0].replace(/\%20/g, '')
                        let messId = arrParamsMeet[1].replace(/\%20/g, '')
                        if (this.userid) {
                            chatDB.users.get(Number(this.userid)).then(user => {
                                let objJoinGroupCall = {
                                    group_id: Number(groupId),
                                    message_id: messId.toString(),
                                    display_name: (user && user.full_name) ? user.full_name : (user && user.phone) ? user.phone : '',
                                    avatar_url: (user && user.profile_url) ? global.rxu.config.get_static + user.profile_url : ''
                                }

                                this.loadHandleSocket(objJoinGroupCall)
                            }).catch((e) => { })

                        }
                    }
                }

            }

            // 
        } catch (e) { }
    }

    loadHandleSocket(objJoinGroupCall) {
        rxio.getWaitConnect((data) => {
            if (rxio.connected) {
                let msgPing = {
                    group_id: Number(objJoinGroupCall.group_id),
                    message_id: objJoinGroupCall.message_id,
                }

                rxio.joinGroupCall(objJoinGroupCall, (dataJoin) => {
                    if (dataJoin && dataJoin.jwt_token) {
                        rxio.pingGroupCall(msgPing)
                        console.log(dataJoin.jwt_token)

                        const domain = global.rxu.config.meet_endpoint
                        let meetUrl = 'https://'+domain+'/'+objJoinGroupCall.message_id+'?jwt='+dataJoin.jwt_token

                        console.log(meetUrl)

                        if (window && window.ipcRenderer && meetUrl) {
                            window.ipcRenderer.send('open-external-link', { link: meetUrl })
                        } else if (window && meetUrl) {
                            window.open(meetUrl, '_self')
                        }

                    }
                })

            } else {
                setTimeout(() => {
                    this.loadHandleSocket(objJoinGroupCall)
                }, 300)
            }
        })
    }


    render() {
        return <></>
    }
}

const mapStateToProps = (state, ownProps) => ({
    netaauth: state.netaauth
})

const mapDispatchToProps = {}

const JoinGroupCallContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(JoinGroupCallComponent_)

export default withRouter(JoinGroupCallContainer)
